import { useEffect, useState } from "react";

function useLocalStorage(key, defaultValue = null) {
    const getStoredValue = () => {
        const stored = localStorage.getItem(key);
        try {
            return stored !== null ? JSON.parse(stored) : defaultValue
        } catch {
            return stored
        }
    };

    const [value, setValue] = useState(getStoredValue);

    useEffect(() => {
        const handleStorageChange = () => {
            setValue(getStoredValue());
        }

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('local-storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange)
            window.removeEventListener('local-storage', handleStorageChange);
        }
    }, [key]);

    const set = newValue => {
        const valueToStore = typeof newValue === 'function' ? newValue(value) : newValue;
        localStorage.setItem(key, valueToStore);
        setValue(valueToStore);
        window.dispatchEvent(new Event('local-storage'));
    }

    const remove = () => {
        localStorage.removeItem(key);
        setValue(defaultValue);
        window.dispatchEvent(new Event('local-storage'));
    }

    return [value, set, remove];
}

export default useLocalStorage;